import React, { useState } from "react";
import cn from "classnames";
import styles from "./Product.module.sass";
import Icon from "../Icon";
import { pb } from "../../services/pocketbase";

const ArticleCard = ({
    className,
    item,
    withoutСheckbox,
}) => {
    const [imageError, setImageError] = useState(false);

    // Fonction pour construire l'URL de l'image
    const getImageUrl = (article) => {
        if (!article || !article.cover_image) return null;
        return `${pb.baseUrl}/api/files/${article.collectionId}/${article.id}/${article.cover_image}`;
    };

    // Fonction pour gérer le clic sur l'article
    const handleReadArticle = () => {
        window.open(`https://edutio.fr/article/${item.id}`, '_blank');
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'Date inconnue';
        try {
            return new Date(dateString).toLocaleDateString('fr-FR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        } catch (error) {
            return 'Date invalide';
        }
    };

    // Fonction pour obtenir le nom de la catégorie
    const getCategoryName = () => {
        return item.expand?.category?.name || 'Non catégorisé';
    };

    return (
        <div
            className={cn(styles.product, className)}
            onClick={handleReadArticle}
        >
            <div className={styles.articlePreview}>
                <div className={styles.imageContainer}>
                    {!imageError && getImageUrl(item) ? (
                        <img 
                            src={getImageUrl(item)}
                            alt={item.title}
                            className={styles.articleImage}
                            onError={() => setImageError(true)}
                        />
                    ) : (
                        <div className={styles.imagePlaceholder}>
                            <Icon name="image" size="32" />
                        </div>
                    )}
                    <div className={styles.categoryBadge}>
                        {getCategoryName()}
                    </div>
                </div>
                
                <div className={styles.articleContent}>
                    <h3 className={styles.articleTitle}>
                        {item.title}
                    </h3>
                    
                    <p className={styles.articleExcerpt}>
                        {item.excerpt}
                    </p>
                    
                    <div className={styles.articleFooter}>
                        <div className={styles.date}>
                            <Icon name="clock" size="14" />
                            {formatDate(item.created)}
                        </div>
                        
                        <div className={styles.readMore}>
                            Lire l'article
                            <Icon name="arrow-right" size="14" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ArticleCard;